import React from "react";

// external package
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowTrendUp } from "@fortawesome/free-solid-svg-icons";

export default function currentPositionComponent() {
  return (
    <div className="current_position">
      <div className="title font-size-30 font-vietnam-600 d-flex justify-content-between align-items-center">
        <span> Current Position</span>
        <a
          href="/history-job"
          rel="noreferrer"
          className="font-size-28 font-vietnam-300 font-black-1"
        >
          <FontAwesomeIcon icon={faArrowTrendUp} />
        </a>
      </div>
      <div className="content mt-2">
        <div className="title">
          <span className="font-size-18 font-vietnam-600">PT. Pegadaian</span>
          <span className="ms-2 font-size-14 font-vietnam-300-italic">
            Agustus 2023 - Present
          </span>
          <div className="font-size-12 font-vietnam-300">
            Central Jakarta, Jakarta, Indonesia (Onsite)
          </div>
        </div>
        <div className="position font-size-14 font-vietnam-300">
          Full Stack Developer
        </div>
      </div>
    </div>
  );
}
